<template>
  <div class="tenant-page">
    <a-card>
      <div class="search-bar">
        <div class="left">
          <a-input-search
            v-model:value="searchText"
            placeholder="租户名称/租户编码"
            style="width: 300px"
            @search="onSearch"
          />
          <a-button type="primary">查 询</a-button>
        </div>
        <a-button type="primary" @click="addNewTenant">+ 新增租户</a-button>
      </div>
      
      <div class="tenant-container">
        <!-- 左侧租户列表 -->
        <div class="tenant-sidebar" style="width: 500px">
          <div class="tenant-list-header">租户列表</div>
          <a-table
            :dataSource="paginatedTenants"
            @change="handleTableChange"
            :pagination="false" 
            :show-header="false"
            row-key="id"
            :customRow="(record: Tenant) => ({
              onClick: () => onRowClick(record),
            })" 
            :rowClassName="(record: Tenant) => record.id === (selectedTenant?.id || '') ? 'ant-table-row-selected' : ''"
          >
            <a-table-column title="租户名称" data-index="name" />
          </a-table>
        </div>
        
        <!-- 右侧租户详情 -->
        <div class="tenant-content" v-if="selectedTenant">
          <a-tabs v-model:activeKey="activeTabKey">
            <a-tab-pane key="basic" tab="租户信息">
              <div class="tenant-basic-info">
                <h3>租户基础信息</h3>
                <template v-if="!isEditing">
                  <a-descriptions bordered :column="3">
                    <a-descriptions-item label="租户名称" :span="1">{{ selectedTenant?.name || '联星平台' }}</a-descriptions-item>
                    <a-descriptions-item label="租户Code" :span="1">{{ selectedTenant?.code || 'default' }}</a-descriptions-item>
                    <a-descriptions-item label="租户描述" :span="1">{{ selectedTenant?.description || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="创建时间" :span="1">{{ selectedTenant?.createTime || '2023-05-02 11:33:06' }}</a-descriptions-item>
                    <a-descriptions-item label="管理员昵称" :span="1">{{ selectedTenant?.adminName || 'administrator' }}</a-descriptions-item>
                    <a-descriptions-item label="管理员账号" :span="1">{{ selectedTenant?.adminAccount || 'administrator' }}</a-descriptions-item>
                    <a-descriptions-item label="管理员邮箱" :span="1">{{ selectedTenant?.adminEmail || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="管理员电话" :span="1">{{ selectedTenant?.adminPhone || '-' }}</a-descriptions-item>
                  </a-descriptions>
                </template>
                <template v-else>
                  <a-form :model="selectedTenant" layout="vertical">
                    <div class="form-row">
                      <a-form-item label="租户名称">
                        <a-input v-model:value="selectedTenant.name" />
                      </a-form-item>
                      <a-form-item label="租户Code">
                        <a-input v-model:value="selectedTenant.code" />
                      </a-form-item>
                      <a-form-item label="租户描述">
                        <a-input v-model:value="selectedTenant.description" />
                      </a-form-item>
                    </div>
                    <div class="form-row">
                      <a-form-item label="创建时间" disabled>
                        <a-input v-model:value="selectedTenant.createTime" disabled />
                      </a-form-item>
                      <a-form-item label="管理员昵称">
                        <a-input v-model:value="selectedTenant.adminName" />
                      </a-form-item>
                      <a-form-item label="管理员账号">
                        <a-input v-model:value="selectedTenant.adminAccount" />
                      </a-form-item>
                    </div>
                    <div class="form-row">
                      <a-form-item label="管理员邮箱">
                        <a-input v-model:value="selectedTenant.adminEmail" />
                      </a-form-item>
                      <a-form-item label="管理员电话">
                        <a-input v-model:value="selectedTenant.adminPhone" />
                      </a-form-item>
                    </div>
                  </a-form>
                </template>
              </div>
              
              <div class="oem-config">
                <h3>OEM配置</h3>
                <template v-if="!isEditing">
                  <a-descriptions bordered :column="3">
                    <a-descriptions-item label="登录页中文标题" :span="1">{{ oemConfig.loginTitleCn || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="登录页英文标题" :span="1">{{ oemConfig.loginTitleEn || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="登录页背景颜色" :span="1">{{ oemConfig.loginBg || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="主体信息" :span="1">{{ oemConfig.mainInfo || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="公安备案号" :span="1">{{ oemConfig.policeRecord || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="ICP备案号" :span="1">{{ oemConfig.icpNumber || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="登录页背景" :span="1">
                      <a-upload
                        v-model:fileList="bgFileList"
                        :customRequest="handleBgUpload"
                        :showUploadList="false"
                      >
                        <a-button>选择文件</a-button>
                      </a-upload>
                    </a-descriptions-item>
                    <a-descriptions-item label="LOGO上传" :span="1">
                      <a-upload
                        v-model:fileList="fileList"
                        :customRequest="handleUpload"
                        :showUploadList="false"
                      >
                        <a-button>选择文件</a-button>
                      </a-upload>
                    </a-descriptions-item>
                  </a-descriptions>
                </template>
                <template v-else>
                  <a-form :model="oemConfig" layout="vertical">
                    <div class="form-row">
                      <a-form-item label="登录页中文标题">
                        <a-input v-model:value="oemConfig.loginTitleCn" />
                      </a-form-item>
                      <a-form-item label="登录页英文标题">
                        <a-input v-model:value="oemConfig.loginTitleEn" />
                      </a-form-item>
                      <a-form-item label="登录页背景颜色">
                        <a-input v-model:value="oemConfig.loginBg" />
                      </a-form-item>
                    </div>
                    <div class="form-row">
                      <a-form-item label="主体信息">
                        <a-input v-model:value="oemConfig.mainInfo" />
                      </a-form-item>
                      <a-form-item label="公安备案号">
                        <a-input v-model:value="oemConfig.policeRecord" />
                      </a-form-item>
                      <a-form-item label="ICP备案号">
                        <a-input v-model:value="oemConfig.icpNumber" />
                      </a-form-item>
                    </div>
                    <div class="form-row">
                      <a-form-item label="登录页背景">
                        <a-upload
                          v-model:fileList="bgFileList"
                          :customRequest="handleBgUpload"
                          :showUploadList="true"
                        >
                          <a-button>选择文件</a-button>
                        </a-upload>
                      </a-form-item>
                      <a-form-item label="LOGO上传">
                        <a-upload
                          v-model:fileList="fileList"
                          :customRequest="handleUpload"
                          :showUploadList="true"
                        >
                          <a-button>选择文件</a-button>
                        </a-upload>
                      </a-form-item>
                    </div>
                  </a-form>
                </template>
              
              </div>
              
              <div class="tenant-url">
                <span>租户访问地址：</span>
                <a :href="`https://platform.cdn.meritar.com/app/core/#/?tenantcode=${selectedTenant?.code || 'default'}`" target="_blank">
                  https://platform.cdn.meritar.com/app/core/#/?tenantcode={{ selectedTenant?.code || 'default' }}
                </a>
                <a-button type="primary" class="copy-btn" size="small" @click="copyUrl">复制链接</a-button>
              </div>
              <!-- 租户操作按钮 -->
              <div class="tenant-actions">
                <template v-if="!isEditing">
                  <a-button type="primary" @click="editTenant(selectedTenant)">编辑</a-button>
                  <a-popconfirm
                    title="确定要删除这个租户吗？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="deleteTenant(selectedTenant)"
                  >
                    <a-button danger>删除</a-button>
                  </a-popconfirm>
                </template>
                <template v-else>
                  <a-button type="primary" @click="saveTenant">保存</a-button>
                  <a-button @click="cancelEdit">取消</a-button>
                </template>
              </div>
            </a-tab-pane>
            <a-tab-pane key="auth" tab="租户授权信息">
              <div class="auth-info">
                <div class="auth-tabs">
                  <a-tabs default-active-key="basic">
                    <a-tab-pane key="basic" tab="基础">
                      <div class="auth-table">
                        <a-table :dataSource="authGroups" :pagination="false" row-key="code">
                          <a-table-column title="" width="50px">
                            <template #default="{ record }">
                              <a-checkbox v-model:checked="record.checked" />
                            </template>
                          </a-table-column>
                          <a-table-column title="名称" data-index="name" />
                          <a-table-column title="授权code" data-index="code" />
                          <a-table-column title="描述" data-index="description" />
                        </a-table>
                      </div>
                    </a-tab-pane>
                    <a-tab-pane key="iot" tab="智联网">
                      <div class="auth-table">
                        <a-table :dataSource="iotAuthGroups" :pagination="false" row-key="code">
                          <a-table-column title="" width="50px">
                            <template #default="{ record }">
                              <a-checkbox v-model:checked="record.checked" />
                            </template>
                          </a-table-column>
                          <a-table-column title="名称" data-index="name" />
                          <a-table-column title="授权code" data-index="code" />
                          <a-table-column title="描述" data-index="description" />
                        </a-table>
                      </div>
                    </a-tab-pane>
                  </a-tabs>
                </div>
                <div class="auth-actions">
                  <a-button type="primary" @click="saveAuth">保存授权</a-button>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="app" tab="租户应用管理">
              <div class="app-list">
                <div class="operation-bar">
                  <a-button type="primary" @click="addNewApp">+ 新增应用</a-button>
                </div>
                <a-table :dataSource="appList" :pagination="false" row-key="id">
                  <a-table-column title="应用名称" data-index="name" />
                  <a-table-column title="AppID" data-index="appId" />
                  <a-table-column title="SecretKey" data-index="secretKey">
                    <template #default="{ record }">
                      {{ record.secretKey ? '********' + record.secretKey.slice(-4) : '' }}
                    </template>
                  </a-table-column>
                  <a-table-column title="创建时间" data-index="createTime" />
                  <a-table-column title="创建人" data-index="creator" />
                  <a-table-column title="操作">
                    <template #default="{ record }">
                      <a-space>
                        <a @click="editApp(record)">编辑</a>
                        <a-popconfirm
                          title="确定要删除这个应用吗？"
                          ok-text="确定"
                          cancel-text="取消"
                          @confirm="deleteApp(record)"
                        >
                          <a>删除</a>
                        </a-popconfirm>
                      </a-space>
                    </template>
                  </a-table-column>
                </a-table>
              </div>
            </a-tab-pane>
            
            <!-- 新增订阅应用管理标签页 -->
            <a-tab-pane key="subscription" tab="订阅应用管理">
              <div class="subscription-list">
                <div class="operation-bar">
                  <a-button type="primary" @click="addNewSubscription">+ 新增订阅</a-button>
                </div>
                <a-table :dataSource="subscriptionList" :pagination="false" row-key="id">
                  <a-table-column title="订阅名称" data-index="name" />
                  <a-table-column title="订阅ID" data-index="subscriptionId" />
                  <a-table-column title="访问密钥" data-index="accessKey">
                    <template #default="{ record }">
                      {{ record.accessKey ? '********' + record.accessKey.slice(-4) : '' }}
                    </template>
                  </a-table-column>
                  <a-table-column title="创建时间" data-index="createTime" />
                  <a-table-column title="创建人" data-index="creator" />
                  <a-table-column title="操作">
                    <template #default="{ record }">
                      <a-space>
                        <a-popconfirm
                          title="确定要承这个订阅吗？"
                          ok-text="确定"
                          cancel-text="取消"
                          @confirm="deleteSubscription(record)"
                        >
                          <a>取消订阅</a>
                        </a-popconfirm>
                      </a-space>
                    </template>
                  </a-table-column>
                </a-table>
              </div>
            </a-tab-pane>
            <a-tab-pane key="system" tab="系统配置">
              <div class="system-config">
                <a-form :model="systemConfig" layout="vertical">
                  <div class="config-section">
                    <h3>注册分配的角色</h3>
                    <a-select
                      v-model:value="systemConfig.defaultRole"
                      style="width: 100%"
                      placeholder="普通用户"
                    >
                      <a-select-option value="user">普通用户</a-select-option>
                      <a-select-option value="admin">管理员</a-select-option>
                      <a-select-option value="superadmin">超级管理员</a-select-option>
                    </a-select>
                  </div>
                  
                  <div class="config-section">
                    <h3>和风天气秘钥</h3>
                    <a-input v-model:value="systemConfig.weatherKey" />
                  </div>
                  
                  <div class="config-section">
                    <h3>同步反馈通知用户</h3>
                    <a-select
                      v-model:value="systemConfig.notifyUsers"
                      mode="multiple"
                      style="width: 100%"
                      placeholder="请选择用户"
                    />
                  </div>
                  
                  <div class="config-section">
                    <h3>是否检查用户注销</h3>
                    <a-radio-group v-model:value="systemConfig.checkUserLogout">
                      <a-radio :value="true">禁止项目管理员注销账号</a-radio>
                      <a-radio :value="false">允许项目管理员注销账号</a-radio>
                    </a-radio-group>
                  </div>
                  
                  <div class="config-section">
                    <h3>启用单会话登录</h3>
                    <a-radio-group v-model:value="systemConfig.singleSession">
                      <a-radio :value="true">启用</a-radio>
                      <a-radio :value="false">禁用</a-radio>
                    </a-radio-group>
                  </div>
                  
                  <div class="config-section">
                    <h3>操作日志保留时间</h3>
                    <a-radio-group v-model:value="systemConfig.logRetention">
                      <a-radio value="forever">永久</a-radio>
                      <a-radio value="custom">自定义</a-radio>
                    </a-radio-group>
                  </div>
                  
                  <div class="config-section">
                    <h3>登陆日志保留时间</h3>
                    <a-radio-group v-model:value="systemConfig.loginLogRetention">
                      <a-radio value="forever">永久</a-radio>
                      <a-radio value="custom">自定义</a-radio>
                    </a-radio-group>
                  </div>
                  
                  <div class="form-actions">
                    <a-button type="primary" @click="saveSystemConfig">保存</a-button>
                  </div>
                </a-form>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <div class="pagination-container" v-if="tenantList.length > 0">
        <a-pagination
          v-model:current="pagination.current"
          v-model:pageSize="pagination.pageSize"
          :total="pagination.total"
          :show-total="pagination.showTotal"
          show-size-changer
          show-quick-jumper
          @change="handleTableChange"
        />
      </div>
    </a-card>
  </div>
  <!-- 新增应用对话框 -->
  <a-modal 
    v-model:visible="showAppDialog" 
    title="新增应用"
    @ok="saveApp"
  >
    <a-form :model="currentApp" layout="vertical">
      <a-form-item label="应用名称">
        <a-input v-model:value="currentApp.name" />
      </a-form-item>
      <a-form-item label="AppID">
        <a-input v-model:value="currentApp.appId" />
      </a-form-item>
      <a-form-item label="SecretKey">
        <a-input-password v-model:value="currentApp.secretKey" />
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 新增应用对话框 -->
  <a-modal 
    v-model:visible="showAppDialog" 
    title="新增应用"
    @ok="saveApp"
  >
    <a-form :model="currentApp" layout="vertical">
      <a-form-item label="应用名称">
        <a-input v-model:value="currentApp.name" />
      </a-form-item>
      <a-form-item label="AppID">
        <a-input v-model:value="currentApp.appId" />
      </a-form-item>
      <a-form-item label="SecretKey">
        <a-input-password v-model:value="currentApp.secretKey" />
      </a-form-item>
    </a-form>
  </a-modal>
  
  <!-- 新增订阅对话框 -->
  <a-modal 
    v-model:visible="showSubscriptionDialog" 
    title="新增订阅"
    @ok="saveSubscription"
  >
    <a-form :model="currentSubscription" layout="vertical">
      <a-form-item label="订阅名称">
        <a-input v-model:value="currentSubscription.name" />
      </a-form-item>
      <a-form-item label="订阅ID">
        <a-input v-model:value="currentSubscription.subscriptionId" />
      </a-form-item>
      <a-form-item label="访问密钥">
        <a-input-password v-model:value="currentSubscription.accessKey" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted, watch } from 'vue'
import { tenantList as tenantData, Tenant, App, Subscription } from '../data/tenantData'

// 组件初始化时执行
onMounted(() => {
  // 默认选中第一个租户
  if (tenantList.value.length > 0 && !selectedTenant.value) {
    selectedTenant.value = tenantList.value[0]
    selectedKeys.value = [tenantList.value[0].id.toString()]
  }
})

// 搜索文本
const searchText = ref('')
// 当前激活的标签页
const activeTabKey = ref('basic')
// 当前选中的菜单项
const selectedKeys = ref<string[]>([])

// 租户列表数据
const tenantList = ref<Tenant[]>(tenantData)

// 当前选中的租户
const selectedTenant = ref<Tenant | null>(null)

// 编辑模式状态
const isEditing = ref(false)

// 分页配置
const pagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
  showTotal: (total: number) => `共 ${total} 条记录`,
  showSizeChanger: true,
  showQuickJumper: true
})

// 分页后的租户数据
const paginatedTenants = computed(() => {
  const start = (pagination.current - 1) * pagination.pageSize
  const end = start + pagination.pageSize
  
  // 使用过滤后的租户列表
  const filtered = filteredTenants.value
  pagination.total = filtered.length
  
  return filtered.slice(start, end)
})

// 处理表格变化
const handleTableChange = (pag: any) => {
  pagination.current = pag.current
  pagination.pageSize = pag.pageSize
}

// OEM配置数据
const oemConfig = reactive<OemConfig>({
  loginTitleCn: '',
  loginTitleEn: '',
  workspace: '',
  publicMenu: '',
  loginBg: '',
  mainInfo: '',
  icpNumber: '',
  policeRecord: '',
  loginBackground: ''
})

// 文件上传列表
const fileList = ref([])
const bgFileList = ref([])

// 过滤后的租户列表
const filteredTenants = computed(() => {
  if (!searchText.value) {
    return tenantList.value
  }
  
  const searchLower = searchText.value.toLowerCase()
  return tenantList.value.filter(tenant => {
    return tenant.name.toLowerCase().includes(searchLower) || 
           tenant.code.toLowerCase().includes(searchLower)
  })
})

// 搜索处理
const onSearch = (value: string) => {
  console.log('search:', value)
  // 重置到第一页
  pagination.current = 1
  
  // 如果找到匹配的租户，选中第一个
  if (filteredTenants.value.length > 0) {
    selectedTenant.value = { ...filteredTenants.value[0] }
    selectedKeys.value = [filteredTenants.value[0].id.toString()]
    activeTabKey.value = 'basic'
  }
}

// 添加新租户
const addNewTenant = () => {
  // 实现添加新租户的逻辑
}

// 查看租户详情
const viewTenant = (record: Tenant) => {
  selectedTenant.value = record
  selectedKeys.value = [record.id.toString()]
  // 重置标签页为基础信息
  activeTabKey.value = 'basic'
}

// 处理表格行点击
const onRowClick = (record: Tenant) => {
  // 创建一个新对象来确保响应式更新
  selectedTenant.value = { ...record }
  selectedKeys.value = [record.id.toString()]
  // 重置标签页为基础信息
  activeTabKey.value = 'basic'
  
  // 添加日志以便调试
  console.log('选中租户:', selectedTenant.value)
}

// 编辑租户
const editTenant = (record: Tenant) => {
  console.log('编辑租户:', record)
  isEditing.value = true
}

// 取消编辑
const cancelEdit = () => {
  isEditing.value = false
}

// 保存租户信息
const saveTenant = () => {
  // 实现保存租户信息的逻辑
  console.log('保存租户信息:', selectedTenant.value)
  // 保存成功后退出编辑模式
  isEditing.value = false
}

// 删除租户
const deleteTenant = (record: Tenant) => {
  // 实现删除租户的逻辑
  console.log('删除租户:', record)
  // 从列表中移除租户
  tenantList.value = tenantList.value.filter(item => item.id !== record.id)
  // 如果删除的是当前选中的租户，则选中第一个租户
  if (selectedTenant.value && selectedTenant.value.id === record.id) {
    if (tenantList.value.length > 0) {
      selectedTenant.value = tenantList.value[0]
      selectedKeys.value = [tenantList.value[0].id.toString()]
    } else {
      selectedTenant.value = null
      selectedKeys.value = []
    }
  }
}

// 复制URL
const copyUrl = () => {
  // 实现复制URL的逻辑
  const url = `https://plant.cdn.meritar.com/app/core/#/?tenantcode=${selectedTenant.value?.code || 'default'}`
  navigator.clipboard.writeText(url)
    .then(() => {
      // 可以添加提示复制成功的逻辑
      console.log('URL已复制到剪贴板')
    })
    .catch(err => {
      console.error('复制失败:', err)
    })
}

// 处理文件上传
const handleUpload = (options: any) => {
  // 实现文件上传逻辑
}

// 处理背景图片上传
const handleBgUpload = (options: any) => {
  // 实现背景图片上传逻辑
}

// 重置配置
const resetConfig = () => {
  // 实现重置配置的逻辑
}

// 保存配置
const saveConfig = () => {
  // 实现保存配置的逻辑
}
const authGroups = ref([
  { name: '角色管理', code: 'group1', description: '', checked: true },
  { name: '用户管理', code: 'group2', description: '', checked: true },
  { name: '租户管理', code: 'group3', description: '', checked: true },
  { name: '部门管理', code: 'group4', description: '', checked: true },
  { name: '任务管理', code: 'group5', description: '', checked: true },
  { name: '模块管理', code: 'group6', description: '', checked: true },
  { name: '通知配置', code: 'group7', description: '', checked: true },
  { name: '租户协议', code: 'group8', description: '', checked: true },
  { name: '拓展管理', code: 'group9', description: '', checked: true },
  { name: '授权管理', code: 'group10', description: '', checked: true },
])

// 智联网授权组数据
const iotAuthGroups = ref([
  { name: '设备管理', code: 'iot1', description: '管理智联网设备', checked: true },
  { name: '产品管理', code: 'iot2', description: '管理智联网产品', checked: true },
  { name: '协议管理', code: 'iot3', description: '管理智联网协议', checked: true },
  { name: '数据分析', code: 'iot4', description: '智联网数据分析', checked: true },
  { name: '告警管理', code: 'iot5', description: '智联网告警管理', checked: true },
])

// 保存授权设置
const saveAuth = () => {
  // 实现保存授权的逻辑
  console.log('保存授权设置:', {
    basic: authGroups.value,
    iot: iotAuthGroups.value
  })
  // 可以添加保存成功的提示
}
// 租户应用列表数据
const appList = ref<App[]>([])

// 监听selectedTenant变化，更新appList
watch(() => selectedTenant.value, (newTenant) => {
  if (newTenant && newTenant.apps) {
    appList.value = [...newTenant.apps]
  } else {
    appList.value = []
  }
}, { immediate: true })


// OEM配置接口定义已经在导入的类型中定义

// OEM配置接口定义
interface OemConfig {
  loginTitleCn: string
  loginTitleEn: string
  workspace: string
  publicMenu: string
  loginBg: string
  mainInfo: string
  icpNumber: string
  policeRecord: string
  loginBackground: string
}

// 编辑应用
const editApp = (record: any) => {
  // 实现编辑应用的逻辑
  console.log('编辑应用:', record)
  currentApp.value = { ...record }
  showAppDialog.value = true
}

// 删除应用
const deleteApp = (record: any) => {
  // 实现删除应用的逻辑
  console.log('删除应用:', record)
  appList.value = appList.value.filter(item => item.id !== record.id)
}
// 新增应用对话框的显示状态
const showAppDialog = ref(false)
// 当前编辑的应用数据
const currentApp = ref({
  id:'',
  name: '',
  appId: '', // 变量名改为appId
  secretKey: '',
  createTime: '',
  creator: ''
})

// 打开新增应用对话框
const addNewApp = () => {
  currentApp.value = {
    id:'',
    name: '',
    appId: '',
    secretKey: '',
    createTime: new Date().toLocaleString(),
    creator: '当前用户'
  }
  showAppDialog.value = true
}

// 保存应用
const saveApp = () => {
  if (!selectedTenant.value) return
  
  // 确保租户有apps属性
  if (!selectedTenant.value.apps) {
    selectedTenant.value.apps = []
  }
  
  // 编辑现有应用
  if (currentApp.value.appId) {
    const index = selectedTenant.value.apps.findIndex(app => app.id === currentApp.value.appId)
    if (index !== -1) {
      selectedTenant.value.apps[index] = { ...currentApp.value }
    }
  } 
  // 添加新应用
  else {
    const newApp = {
      ...currentApp.value,
      id: Date.now().toString(), // 生成唯一ID
      createTime: new Date().toLocaleString(),
      creator: '当前用户' // 这里应该使用实际的当前登录用户
    }
    selectedTenant.value.apps.push(newApp)
  }

  // 删除应用
const deleteApp = (record: any) => {
  if (!selectedTenant.value || !selectedTenant.value.apps) return
  
  selectedTenant.value.apps = selectedTenant.value.apps.filter(app => app.id !== record.id)
}
  
  showAppDialog.value = false
  // 重置当前应用
  currentApp.value = {
    id:'',
    name: '',
    appId: '',
    secretKey: '',
    createTime: '',
    creator: ''
  }
}

// 系统配置数据
const systemConfig = reactive({
  defaultRole: 'user', // 默认选择普通用户
  weatherKey: '',
  notifyUsers: [],
  checkUserLogout: false,
  singleSession: false,
  logRetention: 'forever',
  loginLogRetention: 'forever'
})

// 保存系统配置
const saveSystemConfig = () => {
  console.log('保存系统配置:', systemConfig)
  // 实现保存系统配置的逻辑
}

// 接口定义已经在导入的类型中

// ... existing code ...

// 租户订阅列表数据
const subscriptionList = computed(() => {
  if (!selectedTenant.value || !selectedTenant.value.subscriptions) {
    return []
  }
  return selectedTenant.value.subscriptions
})

// 新增订阅对话框的显示状态
const showSubscriptionDialog = ref(false)

// 当前编辑的订阅数据
const currentSubscription = ref({
  id:'',
  name: '',
  subscriptionId: '',
  accessKey: '',
  createTime: '',
  creator: ''
})

// 打开新增订阅对话框
const addNewSubscription = () => {
  currentSubscription.value = {
    id:'',
    name: '',
    subscriptionId: '',
    accessKey: '',
    createTime: new Date().toLocaleString(),
    creator: '当前用户'
  }
  showSubscriptionDialog.value = true
}

// 编辑订阅
const editSubscription = (record: any) => {
  console.log('编辑订阅:', record)
  currentSubscription.value = { ...record }
  showSubscriptionDialog.value = true
}

// 保存订阅
const saveSubscription = () => {
  if (!selectedTenant.value) return
  
  // 确保租户有subscriptions属性
  if (!selectedTenant.value.subscriptions) {
    selectedTenant.value.subscriptions = []
  }
  
  // 编辑现有订阅
  if (currentSubscription.value.subscriptionId) {
    const index = selectedTenant.value.subscriptions.findIndex(sub => sub.id === currentSubscription.value.subscriptionId)
    if (index !== -1) {
      selectedTenant.value.subscriptions[index] = { ...currentSubscription.value }
    }
  } 
  // 添加新订阅
  else {
    const newSubscription = {
      ...currentSubscription.value,
      id: Date.now().toString(), // 生成唯一ID
      createTime: new Date().toLocaleString(),
      creator: '当前用户' // 这里应该使用实际的当前登录用户
    }
    selectedTenant.value.subscriptions.push(newSubscription)
  }
  
  showSubscriptionDialog.value = false
  // 重置当前订阅
  currentSubscription.value = {
    id:'',
    name: '',
    subscriptionId: '',
    accessKey: '',
    createTime: '',
    creator: ''
  }
}

// 删除订阅
const deleteSubscription = (record: any) => {
  if (!selectedTenant.value || !selectedTenant.value.subscriptions) return
  
  selectedTenant.value.subscriptions = selectedTenant.value.subscriptions.filter(sub => sub.id !== record.id)
}
</script>

<script lang="ts">
export default {
  name: 'TenantManager'
}
</script>

<style scoped>
.system-config {
  padding: 24px;
}

.config-section {
  margin-bottom: 24px;
}

.config-section h3 {
  margin-bottom: 16px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}

.form-actions {
  margin-top: 32px;
}
</style>

<style scoped>
.tenant-page {
  padding: 24px;
  background: #f5f7f9;
  min-height: 100vh;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.search-bar .left {
  display: flex;
  gap: 8px;
}

.tenant-container {
  display: flex;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  overflow: hidden;
}

.tenant-sidebar {
  width: 100%;
  padding: 16px;
  background: #fff;
  border-radius: 4px;
}

.tenant-list-header {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 500;
}

.tenant-menu {
  border-right: none;
}

.tenant-content {
  flex: 1;
  padding: 16px;
  background-color: #fff;
}

.tenant-actions {
  margin-top: 16px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.tenant-basic-info {
  margin-bottom: 24px;
}

.info-row {
  display: flex;
  margin-bottom: 16px;
}

.info-item {
  flex: 1;
  display: flex;
}

.info-item .label {
  width: 100px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: normal;
}

.oem-config {
  margin: 24px 0;
}

.form-row {
  display: flex;
  gap: 16px;
}

.form-row .ant-form-item {
  flex: 1;
}

.tenant-url {
  margin: 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
}

.copy-btn {
  margin-left: auto;
  background-color: #52c41a;
  border-color: #52c41a;
}

.action-buttons {
  margin-top: 24px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

:deep(.ant-descriptions) {
  margin: 16px 0;
}

:deep(.ant-form-item) {
  margin-bottom: 16px;
}
.auth-info {
  margin-top: 16px;
}

.auth-tabs {
  background-color: #fff;
  border-radius: 4px;
}

.auth-table {
  margin-top: 16px;
}

.auth-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.pagination-container {
  display: flex;
  justify-content: flex-end; /* 或者 center，根据您的偏好 */
  margin-top: 16px;
}
</style>

